<template lang='pug'>
div
	.tw-flex.tw-text-black
		div.tw-border-r.tw-text-center.tw-p-3
			.tw-font-bold.tw-text-xs.tw-text-slate-400 {{ departureMonth }} {{departureYear}}
			.tw-text-xl.tw-font-semibold {{departure.getDate()}}
		div.tss-travel-bar-details.tw-p-3
			.tw-text-lg.tw-font-semibold {{travelSolution.start.stationName}}
				span.tss-stations-arrow.mdi.mdi-arrow-right-thin.mx-2
				span {{travelSolution.end.stationName}}
			.tw-text-xs(v-if="searchCriteria")
				span(v-if="searchCriteria.adult > 0") {{searchCriteria.adult}} {{searchCriteria.adult == 1 ? $t('common.adult', 0) : $t('common.adult', 1)}}
				span(v-if="searchCriteria.children > 0")
					span(v-if="searchCriteria.adult > 0") &nbsp;+
					span &nbsp;{{searchCriteria.children}} {{searchCriteria.children == 1 ? $t('common.children', 0) : $t('common.children', 0)}}
			//.tw-text-xs A/R 26 Lug . 4 adulti + 2 bambini

	.tw-p-4(class="tw-bg-[#efefef] emd:tw-p-0")
		p.tw-mb-2.tw-font-medium {{title}}
		template(v-for="(train, i) in travelSolution.trains" :key="i")
			.tw-card.tw-bg-white.tw-border-0.tw-mb-3
				div.tw-pb-3
					div
						img.train-icon(v-if="trainBreadcrumbs[i].icon" :src="trainBreadcrumbs[i].icon" style="max-height: 11px;")
						strong(class="tw-text-[12px]") {{ trainBreadcrumbs[i].name }}
						span(v-if="i < (trainBreadcrumbs[i].length - 1)") /
					div.tw-flex.tw-items-center
						div
							span.tw-text-lg.tw-font-normal(class="tw-text-primary-dark tw-text-semibold") {{departureHour}}
							br
							span.tw-text-base.tw-font-medium {{train.start.stationName}}
						div.tw-grow.tw-flex
							div.tw-flex-1.tw-flex.tw-items-center.tw-justify-center
								hr(class="tw-w-3/4 tw-h-0 tw-border-dashed tw-border-t-[0.063rem] tw-border-[#e3e6ed] tw-box-content")
							span.tw-font-medium {{ train.duration }}
							div.tw-flex-1.tw-flex.tw-items-center.tw-justify-center
								hr(class="tw-w-3/4 tw-h-0 tw-border-dashed tw-border-t-[0.063rem] tw-border-[#e3e6ed] tw-box-content")
						div
							span.tw-text-lg.tw-font-normal(class="tw-text-primary-dark tw-text-semibold") {{arrivalHour}}
							br
							span.tw-text-base.tw-font-medium {{train.end.stationName}}

				div.tw-border-t-2.tw-pt-3
					template(v-for="(passenger, i) in passengers" :key="i")
						hr.tw-my-2(v-if="passengers.length > 1 && i > 0")
						travelsolution-passenger-summary(:passenger="passenger" :passenger-k="i" :train-id="train.id" :travel-solution="props.travelSolution" :travel-type="travelType")
</template>

<script setup>
import {computed} from "vue";
import {getTrainBreadcrumbs} from "@/common-scripts/train-helper";
import {capitalizeFirstLetter} from "../../common-scripts/utilities";
import TravelsolutionPassengerSummary from "@/common-components/travelsolution-passenger-summary.vue";
import {useI18n} from "vue-i18n";

const i18n = useI18n();
const emit = defineEmits(['clicked']);
const props = defineProps({
	show: {
		type: Boolean,
		default: true
	},
	searchCriteria: Object,
	travelSolution: Object,
	passengers: Array,
	isForward: {
		type: Boolean,
		default: false
	},
	isReturn: {
		type: Boolean,
		default: false
	}
});
const trainBreadcrumbs = computed(() => getTrainBreadcrumbs(props.travelSolution.trains));
const departure = computed(() => new Date(props.travelSolution.departure));
const arrival = computed(() => new Date(props.travelSolution.arrival));
const departureYear = computed(() => departure.value.toLocaleString(i18n.locale.value, {year:'numeric'}));
const departureMonth = computed(() => capitalizeFirstLetter(departure.value.toLocaleString(i18n.locale.value, {month:'long'})));
const departureHour = computed(() => capitalizeFirstLetter(departure.value.toLocaleTimeString(i18n.locale.value, {hour:'2-digit', minute:'2-digit', hour12: false})));
const arrivalHour = computed(() => capitalizeFirstLetter(arrival.value.toLocaleTimeString(i18n.locale.value, {hour:'2-digit', minute:'2-digit', hour12: false})));
const title = computed(() => {
	if (!props.isForward && !props.isReturn) {
		return i18n.t('postsale.travel_solution_detail.travel', 'VIAGGIO').toUpperCase();
	} else {
		return props.isForward ? i18n.t('form_labels.departure', 'ANDATA').toUpperCase() : i18n.t('form_labels.return', 'RITORNO').toUpperCase()
	}
});
const travelType = computed(() => {
	if (!props.isForward && !props.isReturn) {
		return 'forward';
	} else {
		return props.isForward ? 'forward' : 'return'
	}
});
</script>

<style scoped>
.v-overlay__content {
	overflow: auto;
}
</style>